import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/design-system.css';

function DataDeletion() {
  return (
    <div className="ps-page">
      <nav className="ps-nav">
        <div className="ps-container">
          <div className="ps-nav__inner">
            <Link to="/" className="ps-nav__logo">
              Postrify <span className="ps-nav__logo-dot" />
            </Link>
            <div className="ps-nav__right">
              <Link to="/" className="ps-btn ps-btn--ghost ps-btn--sm">← Home</Link>
            </div>
          </div>
        </div>
      </nav>

      <div className="ps-container" style={{ maxWidth: '820px', paddingTop: '40px', paddingBottom: '80px' }}>
        <div style={{ marginBottom: '36px' }}>
          <span style={{ display: 'inline-block', fontSize: '12px', fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#4f46e5', marginBottom: '12px' }}>Legal</span>
          <h1 style={{ fontFamily: 'Inter, sans-serif', fontSize: 'clamp(28px,4vw,40px)', fontWeight: 800, letterSpacing: '-0.6px', marginBottom: '10px' }}>Data Deletion</h1>
          <p style={{ fontSize: '14px', color: '#8b8aab' }}>Last updated: March 27, 2026 — GDPR &amp; CCPA compliant</p>
        </div>

        <div className="ps-card" style={{ lineHeight: '1.8', fontSize: '15px', color: '#4b4a6b' }}>
          <LegalSection title="1. Data We Collect">
            <p>When you use Postrify, we collect and store:</p>
            <ul>
              <li>Your email, username, and full name</li>
              <li>Brand information (names, niches, tone preferences, logos)</li>
              <li>Generated posts, images, and captions</li>
              <li>OAuth access tokens and refresh tokens for Facebook and Instagram (encrypted)</li>
              <li>Social media platform identifiers (page IDs, account IDs)</li>
              <li>Usage logs and analytics data</li>
            </ul>
          </LegalSection>

          <LegalSection title="2. How to Delete Your Data">
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              <div style={{ padding: '20px', background: '#f8f8fc', borderRadius: '12px', border: '1.5px solid #e4e4ef' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                  <span style={{ background: '#4f46e5', color: '#fff', borderRadius: '50%', width: '24px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: '13px', flexShrink: 0 }}>✓</span>
                  <strong style={{ color: '#16152e', fontSize: '15px' }}>Delete from Dashboard (Recommended)</strong>
                </div>
                <ol style={{ paddingLeft: '34px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
                  <li>Log in to your Postrify account</li>
                  <li>Go to <strong>Account Settings</strong></li>
                  <li>Scroll to <strong>Danger Zone</strong></li>
                  <li>Click <strong>Delete Account</strong></li>
                  <li>Confirm by entering "DELETE"</li>
                </ol>
                <p style={{ marginTop: '12px', fontSize: '13px', color: '#065f46', background: '#d1fae5', padding: '8px 12px', borderRadius: '6px', fontWeight: 500 }}>
                  All data deleted within 48 hours. This cannot be undone.
                </p>
              </div>

              <div style={{ padding: '20px', background: '#f8f8fc', borderRadius: '12px', border: '1.5px solid #e4e4ef' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
                  <span style={{ background: '#7c3aed', color: '#fff', borderRadius: '50%', width: '24px', height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: '13px', flexShrink: 0 }}>📧</span>
                  <strong style={{ color: '#16152e', fontSize: '15px' }}>Manual Deletion Request</strong>
                </div>
                <p style={{ marginBottom: '12px' }}>Email <strong>support.postrify@gmail.com</strong> with:</p>
                <ul style={{ marginBottom: '12px' }}>
                  <li>Subject: Use <strong>"Data Deletion Request"</strong> (or <strong>"GDPR Article 17"</strong> for EU, <strong>"CCPA Deletion"</strong> for California)</li>
                  <li>Your full name</li>
                  <li>Account email address</li>
                  <li>Facebook/Instagram email (if linked)</li>
                </ul>
                <p style={{ fontSize: '13px', color: '#7c3aed', background: '#ede9fe', padding: '8px 12px', borderRadius: '6px' }}>
                  Response: 15 days (GDPR) | 45 days (CCPA) | 72 hours (standard)
                </p>
              </div>
            </div>
          </LegalSection>

          <LegalSection title="3. What Gets Deleted">
            <ul>
              <li><strong>Profile Data:</strong> Email, username, password hash, settings</li>
              <li><strong>Brands:</strong> All brand profiles, logos, preferences</li>
              <li><strong>Posts &amp; Images:</strong> All generated content</li>
              <li><strong>OAuth Tokens:</strong> Facebook and Instagram access/refresh tokens</li>
              <li><strong>Uploaded Files:</strong> Logos and generated images</li>
              <li><strong>Usage Data:</strong> Logs and analytics</li>
            </ul>
            <p style={{ marginTop: '14px', fontSize: '14px', color: '#dc2626', background: '#fee2e2', padding: '10px 12px', borderRadius: '6px' }}>
              <strong>Note:</strong> Content published to Facebook/Instagram must be deleted separately through those platforms.
            </p>
          </LegalSection>

          <LegalSection title="4. Deletion Timeline">
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
              <thead>
                <tr style={{ background: '#f1f0f9' }}>
                  <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 700, color: '#16152e' }}>Data Type</th>
                  <th style={{ padding: '12px 16px', textAlign: 'left', fontWeight: 700, color: '#16152e' }}>Timeline</th>
                </tr>
              </thead>
              <tbody>
                <tr style={{ borderBottom: '1px solid #e4e4ef' }}>
                  <td style={{ padding: '12px 16px', color: '#16152e', fontWeight: 500 }}>Account Profile</td>
                  <td style={{ padding: '12px 16px', color: '#4b4a6b' }}>Within 24 hours</td>
                </tr>
                <tr style={{ borderBottom: '1px solid #e4e4ef' }}>
                  <td style={{ padding: '12px 16px', color: '#16152e', fontWeight: 500 }}>Generated Posts &amp; Images</td>
                  <td style={{ padding: '12px 16px', color: '#4b4a6b' }}>Within 48 hours</td>
                </tr>
                <tr style={{ borderBottom: '1px solid #e4e4ef' }}>
                  <td style={{ padding: '12px 16px', color: '#16152e', fontWeight: 500 }}>OAuth Tokens</td>
                  <td style={{ padding: '12px 16px', color: '#4b4a6b' }}>Immediate</td>
                </tr>
                <tr style={{ borderBottom: '1px solid #e4e4ef' }}>
                  <td style={{ padding: '12px 16px', color: '#16152e', fontWeight: 500 }}>Backup Copies</td>
                  <td style={{ padding: '12px 16px', color: '#4b4a6b' }}>30 days</td>
                </tr>
                <tr>
                  <td style={{ padding: '12px 16px', color: '#16152e', fontWeight: 500 }}>Anonymized Logs</td>
                  <td style={{ padding: '12px 16px', color: '#4b4a6b' }}>90 days</td>
                </tr>
              </tbody>
            </table>
          </LegalSection>

          <LegalSection title="5. Legal Exceptions">
            <p>We may retain data if required by law or for legitimate purposes:</p>
            <ul>
              <li>Accounting records (anonymized)</li>
              <li>Legal compliance and dispute resolution</li>
              <li>Fraud prevention and security</li>
              <li>System backups (deleted within 30 days)</li>
            </ul>
          </LegalSection>

          <LegalSection title="6. Disconnect Social Accounts (Optional)">
            <p>To disconnect Facebook/Instagram <em>without deleting</em> your Postrify account:</p>
            <ol>
              <li>Go to <strong>Brand Settings</strong></li>
              <li>Find the social account card</li>
              <li>Click <strong>Disconnect</strong></li>
              <li>Confirm</li>
            </ol>
            <p>✓ This revokes access immediately and deletes OAuth tokens.</p>
          </LegalSection>

          <LegalSection title="7. GDPR Rights (EU Residents)">
            <p><strong>You have the right to:</strong></p>
            <ul>
              <li>Access, correct, or erase your personal data</li>
              <li>Export your data in portable format</li>
              <li>Restrict or object to data processing</li>
              <li>Lodge a complaint with your national Data Protection Authority</li>
            </ul>
            <p><strong>Request:</strong> Email support.postrify@gmail.com with "GDPR Article 17 Request"</p>
            <p style={{ marginTop: '8px', fontSize: '13px', color: '#065f46', background: '#d1fae5', padding: '8px 12px', borderRadius: '6px' }}>
              ⏱ Response: 15 days (may extend 2 months for complex requests)
            </p>
          </LegalSection>

          <LegalSection title="8. CCPA Rights (California Residents)">
            <p><strong>You have the right to:</strong></p>
            <ul>
              <li><strong>Know:</strong> What personal data we collect, use, and share</li>
              <li><strong>Delete:</strong> Your personal data (with some exceptions)</li>
              <li><strong>Opt-Out:</strong> Of data sales to third parties (we do NOT sell data)</li>
              <li><strong>Non-Discrimination:</strong> No penalty for exercising these rights</li>
            </ul>
            <p><strong>Request:</strong> Email support.postrify@gmail.com with "CCPA Data Right Request"</p>
            <p style={{ marginTop: '8px', fontSize: '13px', color: '#059669', background: '#ecfdf5', padding: '8px 12px', borderRadius: '6px' }}>
              ⏱ Response: 45 days (2 requests per 12 months)
            </p>
          </LegalSection>

          <LegalSection title="9. Questions?" last>
            <p style={{ marginBottom: '14px' }}>Contact our Data Protection Team:</p>
            <a href="mailto:support.postrify@gmail.com" style={{ display: 'inline-block', padding: '12px 20px', background: '#e0e7ff', borderRadius: '8px', color: '#3730a3', fontWeight: 700, fontSize: '15px', textDecoration: 'none' }}>
              support.postrify@gmail.com
            </a>
            <p style={{ marginTop: '16px', fontSize: '13px', color: '#8b8aab' }}>
              <Link to="/privacy" style={{ color: '#4f46e5', fontWeight: 600 }}>Privacy Policy</Link> | <Link to="/terms" style={{ color: '#4f46e5', fontWeight: 600 }}>Terms of Service</Link>
            </p>
          </LegalSection>
        </div>
      </div>

      <footer className="ps-footer">
        <div className="ps-container">
          © 2026 Postrify · <Link to="/privacy">Privacy</Link> · <Link to="/terms">Terms</Link>
        </div>
      </footer>
    </div>
  );
}

function LegalSection({ title, children, last }) {
  return (
    <div style={{ marginBottom: last ? 0 : '36px', paddingBottom: last ? 0 : '36px', borderBottom: last ? 'none' : '1px solid #e4e4ef' }}>
      <h2 style={{ fontFamily: 'Inter, sans-serif', fontSize: '18px', fontWeight: 700, color: '#16152e', marginBottom: '14px' }}>{title}</h2>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
        {children}
      </div>
    </div>
  );
}

export default DataDeletion;
